import React from "react";
import { FaRegTimesCircle, FaRegAddressCard } from "react-icons/fa";
import { TbFaceId } from "react-icons/tb";
import { logo, smallLogo } from "../../../assets/images";
import { useUser } from "../../../context/user-context";

const Kyc3Onboarding = ({
  setOpenKyc3Start,
  setOpenKyc3,
  setOpenKyc3Screens,
}: any) => {
  const { theme } = useUser();

  return (
    <div className="fixed inset-0  flex font-manrope justify-start items-start pt-16 overflow-auto pb-16 bg-[#E7EBEE] dark:bg-primary_dark dark:bg-opacity-95  backdrop-blur-sm">
      <div
        className={` w-11/12 mds:w-8/12 md:7/12 border dark:border-[#303030] bg-white  rounded-xl mx-auto p-6 dark:bg-[#192025]   lgss:w-2/5 xxl:w-1/3 `}
      >
        {" "}
        <div className="flex px-3 mt-4 gap-12 justify-center items-center">
          <div className="">
            {theme === "dark" ? (
              <img src={logo} className="mx-auto " alt="" />
            ) : (
              <img src={smallLogo} className="mx-auto " alt="" />
            )}
          </div>{" "}
          <FaRegTimesCircle
            onClick={() => {
              setOpenKyc3Start(false);
              setOpenKyc3(true);
            }}
            className="text-gray-800 dark:text-gray-500 text-[22px] cursor-pointer"
          />
        </div>
        <div className="w-full px-4 flex flex-col mt-6 items-center justify-center">
          <div className="px-4 mds:px-6  py-6  rounded-xl bg-white dark:bg-transparent flex flex-col items-center justify-center ">
            <h4 className="text-[17px] dark:text-gray-300 text-paragraph font-sora font-semibold">
              Let’s verify your identity
            </h4>
            <h6 className="text-[#869AA9] dark:text-gray-500 lgss:text-[13px] mt-1">
              To get verified, you will need to:{" "}
            </h6>
            <div className="flex gap-2 mt-8">
              <div className="w-[120px] h-[120px] rounded-full bg-[#E8F3FC] dark:bg-secondary_button flex flex-col justify-between items-start">
                <div className="w-[36px] h-[36px]   bg-[#06416C] flex justify-center items-center rounded-full">
                  <h4 className="text-[18px] lgss:text-[22px]  text-white  font-manrope font-medium">
                    1
                  </h4>
                </div>
                <FaRegAddressCard className="text-secondary_button dark:text-gray-100 text-[54px] relative -top-[27%] mx-auto" />
              </div>
            </div>
            <h6 className="text-[#869AA9] dark:text-gray-500 text-center  text-[13px] mt-4">
              We need the correct information of your BVN and a
            </h6>
            <div className="flex gap-2 mt-6">
              <div className="w-[120px] h-[120px] rounded-full bg-[#E8F3FC] dark:bg-secondary_button flex flex-col justify-between items-start">
                <div className="w-[36px] h-[36px]   bg-[#06416C] flex justify-center items-center rounded-full">
                  <h4 className="text-[18px] lgss:text-[22px]  text-white  font-manrope font-medium">
                    2
                  </h4>
                </div>
                <TbFaceId className="text-secondary_button dark:text-gray-100 text-[54px] relative -top-[27%] animate-pulse mx-auto" />
              </div>
            </div>
            <h6 className="text-[#869AA9] dark:text-gray-500 text-center  text-[13px] mt-4">
              A short self video record
            </h6>
            <button
              onClick={() => {
                setOpenKyc3Start(false);
                setOpenKyc3Screens(true);
              }}
              className="w-full h-[52px] flex justify-center text-[15px] items-center mt-8 font-semibold text-white rounded-xl bg-secondary_button"
            >
              Start
            </button>
            <h6 className="text-[#869AA9] dark:text-gray-500 text-center  text-[13px] mt-4">
              By clicking the “Start” button, you agree to our User Terms and
              Conditions and our Privacy Policy
            </h6>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Kyc3Onboarding;
